import { render, staticRenderFns } from "./card-title.vue?vue&type=template&id=01af66ab&scoped=true&"
import script from "./card-title.vue?vue&type=script&lang=js&"
export * from "./card-title.vue?vue&type=script&lang=js&"
import style0 from "./card-title.vue?vue&type=style&index=0&id=01af66ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af66ab",
  null
  
)

export default component.exports